// import { Box, Checkbox, FormControlLabel, Grid, Radio, Slider, Typography } from '@mui/material'
// import React, { useState } from 'react'


// const brands = [
//     { name: 'Nike', count: 2398 },
//     { name: 'Under Armor', count: 1285 },
//     { name: 'Reebok', count: 1285 },
//     { name: 'Pooma', count: 234 },
//     { name: 'Diadora', count: 4783 },
//     { name: 'Umbro', count: 874 },
//     { name: 'Adidas', count: 4830 },
// ];

// const colors = [
//     { name: 'White', count: 2398 },
//     { name: 'Black', count: 1285 },
//     { name: 'Blue', count: 1285 },
//     { name: 'Navy Blue', count: 234 },
//     { name: 'Green', count: 4783 },
//     { name: 'Red', count: 874 },
//     { name: 'Yellow', count: 4830 },
// ];

// const discountRanges = [
//     '10% and above',
//     '20% and above',
//     '30% and above',
//     '40% and above',
//     '50% and above',
//     '60% and above',
//     '70% and above',
// ];


// function ProductListing() {
//     const [price, setPrice] = useState<number[]>([10, 15000]);
//     const [selectedDiscount, setSelectedDiscount] = useState('');

//     const handlePriceChange = (_: Event, newValue: number | number[]) => {
//         setPrice(newValue as number[]);
//     };

//     return (
//         <Box className='h-content w-100 p-3 p-md-5 position-relative'>
//             <Grid container>
//                 <Grid size={{ xs: 0, sm: 3.5, lg: 3, xl: 2.5 }} className='h-100 d-none d-sm-inline-block'>
//                     <Typography className='fs-14 text-white mb-2' gutterBottom>Shoes - 4527 items</Typography>
//                     <Typography className='text-white fw-bold fs-18 mb-4' gutterBottom>FILTERS</Typography>
//                     <Box className='bg-main border-10 mx-3'>
//                         <Box className='filters p-4'>
//                             <Typography className='fs-16 text-white fw-medium mb-2' gutterBottom>BRAND</Typography>
//                             {brands.map((brand) => (
//                                 <FormControlLabel
//                                     key={brand.name}
//                                     control={
//                                         <Checkbox
//                                             className='text-white p-2 border-10'
//                                             size="small"
//                                         />
//                                     }
//                                     label={
//                                         <Box className='d-flex align-items-center gap-1'>
//                                             <Typography className='fs-14 text-white'>
//                                                 {brand.name}
//                                             </Typography>
//                                             <Typography className='fs-12 text-grey'>
//                                                 ({brand.count})
//                                             </Typography>
//                                         </Box>
//                                     }
//                                     sx={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         margin: 0,
//                                         width: '100%',
//                                         '& .MuiFormControlLabel-label': {
//                                             flex: 1,
//                                         },
//                                     }}
//                                 />
//                             ))}
//                         </Box>
//                         <hr className='w-100 border-white m-0' />
//                         <Box className='filters p-4'>
//                             <Typography className='fs-16 text-white fw-medium mb-2' gutterBottom>PRICE</Typography>
//                             <Slider
//                                 className='slider'
//                                 value={price}
//                                 onChange={handlePriceChange}
//                                 min={10}
//                                 max={15000}
//                                 valueLabelDisplay="off"
//                             />
//                             <Box className='d-flex align-items-center justify-content-between'>
//                                 <Typography className='fs-14 text-white fw-bold'>
//                                     $ {price[0].toLocaleString()}
//                                 </Typography>
//                                 <Typography className='fs-14 text-white fw-bold'>
//                                     $ {price[1].toLocaleString()}
//                                 </Typography>
//                             </Box>

//                         </Box>
//                         <hr className='w-100 border-white m-0' />
//                         <Box className='filters p-4'>
//                             <Typography className='fs-16 text-white fw-medium mb-2' gutterBottom>COLOR</Typography>
//                             {colors.map((color) => (
//                                 <FormControlLabel
//                                     key={color.name}
//                                     control={
//                                         <Checkbox
//                                             className='text-white p-2 border-10'
//                                             size="small"
//                                         />
//                                     }
//                                     label={
//                                         <Box className='d-flex align-items-center gap-1'>
//                                             <Typography className='fs-14 text-white'>
//                                                 {color.name}
//                                             </Typography>
//                                             <Typography className='fs-12 text-grey'>
//                                                 ({color.count})
//                                             </Typography>
//                                         </Box>
//                                     }
//                                     sx={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         margin: 0,
//                                         width: '100%',
//                                         '& .MuiFormControlLabel-label': {
//                                             flex: 1,
//                                         },
//                                     }}
//                                 />
//                             ))}
//                         </Box>
//                         <hr className='w-100 border-white m-0' />
//                         <Box className='filters p-4'>
//                             <Typography className='fs-16 text-white fw-medium mb-2' gutterBottom>DISCOUNT</Typography>
//                             {discountRanges.map((discount) => (
//                                 <FormControlLabel
//                                     key={discount}
//                                     control={
//                                         <Radio
//                                         className='radio p-2'
//                                             size="small"
//                                             checked={selectedDiscount === discount}
//                                             onChange={() => setSelectedDiscount(discount)}
//                                         />
//                                     }
//                                     label={
//                                         <Typography className='fs-14 text-white'>
//                                             {discount}
//                                         </Typography>
//                                     }
//                                     sx={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         margin: 0,
//                                         width: '100%',
//                                     }}
//                                 />
//                             ))}
//                         </Box>
//                     </Box>
//                 </Grid>
//                 <Grid size={{ xs: 12, sm: 8.5, lg: 9, xl: 9.5 }}>
//                     <Grid container spacing={{ xs: 2, md: 3 }}>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                         <Grid size={{ xs: 6, sm: 4, xl: 3 }}>
//                             <Box component={'img'} width={'100%'} sx={{ height: { xs: "150px", sm: '300px' } }} className='border mb-2' />
//                             <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
//                             <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
//                             <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
//                         </Grid>
//                     </Grid>
//                 </Grid>
//             </Grid>
//         </Box>
//     )
// }

// export default ProductListing
import {
  Box, Button, Checkbox, Drawer, FormControlLabel, Grid,
  IconButton, Radio, Slider, Typography
} from '@mui/material'
import { FilterList, Close } from '@mui/icons-material'
import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ApiGetAllProducts, ApiGetNewArrivals } from '../Core/Apicall'
import { toast } from 'react-toastify'
import { Product } from '../Models/Products'
import ProductCard from '../Component/ProductCard/ProductCard'
import { Shimmer } from '../Component/Skeletones/Skeletones'
import { useSelector } from 'react-redux'
import { RootState } from '../Redux/store'
import { stat } from 'fs'
import { Color } from '../Models/Color'
import { Size } from '../Models/Size'


const discountRanges = [
  {
    name: "10% and above",
    value: "10"
  },
  {
    name: "20% and above",
    value: "20"
  },
  {
    name: "30% and above",
    value: "30"
  },
  {
    name: "40% and above",
    value: "40"
  },
  {
    name: "50% and above",
    value: "50"
  },
  {
    name: "60% and above",
    value: "60"
  },
]


const FilterContent = ({
  price,
  onPriceChange,
  selectedDiscount,
  selectedColors,
  selectedSizes,
  setSelectedDiscount,
  handleColorChange,
  handleSizeChange

}: {
  price: number[];
  onPriceChange: (_: Event, val: number | number[]) => void;
  selectedDiscount: any;
  setSelectedDiscount: (val: any) => void;
  selectedColors: number[];
  selectedSizes: number[];
  handleColorChange: (colorId: number) => void;
  handleSizeChange: (sizeId: number) => void;
}) => {
  const { allColors, allSizes } = useSelector((state: RootState) => state.global)
  return (
    <Box className='bg-main border-10 mx-2'>
      {/* Colors */}
      <Box className='filters p-4'>
        <Typography className='fs-16 text-white fw-medium mb-2'>COLOR</Typography>
        {allColors.map((color: Color) => (
          <FormControlLabel
            key={color.colorId}
            control={
              <Checkbox
                className="text-white p-2"
                size="small"
                checked={selectedColors.includes(color.colorId)}
                onChange={() => handleColorChange(color.colorId)}
              />
            }
            label={
              <Box className='d-flex align-items-center gap-1'>
                <Typography className='fs-14 text-white'>{color.name}</Typography>
                {/* <Typography className='fs-12 text-grey'>({brand.count})</Typography> */}
              </Box>
            }
            sx={{ display: 'flex', alignItems: 'center', margin: 0, width: '100%', '& .MuiFormControlLabel-label': { flex: 1 } }}
          />
        ))}
      </Box>

      <hr className='w-100 border-white m-0' />

      {/* Price */}
      <Box className='filters p-4'>
        <Typography className='fs-16 text-white fw-medium mb-2'>PRICE</Typography>
        <Slider className='slider' value={price} onChange={onPriceChange} min={10} max={400} valueLabelDisplay='off' />
        <Box className='d-flex align-items-center justify-content-between'>
          <Typography className='fs-14 text-white fw-bold'>$ {price[0].toLocaleString()}</Typography>
          <Typography className='fs-14 text-white fw-bold'>$ {price[1].toLocaleString()}</Typography>
        </Box>
      </Box>

      <hr className='w-100 border-white m-0' />

      {/* Size */}
      <Box className='filters p-4'>
        <Typography className='fs-16 text-white fw-medium mb-2'>SIZE</Typography>
        {allSizes.map((size: Size) => (
          <FormControlLabel
            key={size.sizeId}
            control={<Checkbox
              className="text-white p-2"
              size="small"
              checked={selectedSizes.includes(size.sizeId)}
              onChange={() => handleSizeChange(size.sizeId)}
            />}
            label={
              <Box className='d-flex align-items-center gap-1'>
                <Typography className='fs-14 text-white'>{size.name}</Typography>
                {/* <Typography className='fs-12 text-grey'>({color.count})</Typography> */}
              </Box>
            }
            sx={{ display: 'flex', alignItems: 'center', margin: 0, width: '100%', '& .MuiFormControlLabel-label': { flex: 1 } }}
          />
        ))}
      </Box>

      <hr className='w-100 border-white m-0' />

      {/* Discount */}
      <Box className='filters p-4'>
        <Typography className='fs-16 text-white fw-medium mb-2'>DISCOUNT</Typography>
        {discountRanges.map((discount, index) => (
          <FormControlLabel
            key={index}
            control={
              <Radio
                className='radio p-2'
                size='small'
                checked={selectedDiscount === discount.value}
                onChange={(e) => setSelectedDiscount(discount.value)}
              />
            }
            label={<Typography className='fs-14 text-white'>{discount?.name}</Typography>}
            sx={{ display: 'flex', alignItems: 'center', margin: 0, width: '100%' }}
          />
        ))}
      </Box>
    </Box>
  )
}

function ProductListing() {
  const [price, setPrice] = useState<number[]>([10, 500])
  const [debouncedPrice, setDebouncedPrice] = useState([10, 500]);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const { type, slug,searchTerm} = useParams();
  // const {loading} = useSelector((state:RootState)=>state.loading)
  const [selectedDiscount, setSelectedDiscount] = useState(type === "discounted-products" ? "30" : null)
  const [selectedColors, setSelectedColors] = useState<number[]>([]);
  const [selectedSizes, setSelectedSizes] = useState<number[]>([]);
  const loadingRef = useRef(false);
  const observerRef = useRef<HTMLDivElement>(null);
  const [products, setProducts] = useState<Product[]>([]);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);


  useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedPrice(price);
  }, 500);

  return () => clearTimeout(timer);
}, [price]);

  const LIMIT = 20;

  const loadProducts = async (
    currentOffset = 0,
    reset = false
  ) => {
    try {
      setLoading(true);

      let res;

      switch (type) {
        case "new-arrivals":
          res = await ApiGetAllProducts(
            `?limit=${LIMIT}&offset=${currentOffset}${slug ? `&categorySlug=${encodeURIComponent(slug)}` : ""}${selectedDiscount ? `&discount=${selectedDiscount}` : ""}${selectedColors?.length > 0 ? `&colorId=${selectedColors?.join(",")}` : ""}${searchTerm ? `&searchTerm=${searchTerm?.trim()}` : ""}${selectedSizes?.length > 0 ? `&sizeId=${selectedSizes?.join(",")}` : ""}${debouncedPrice?.length > 0? `&minPrice=${debouncedPrice[0]}&maxPrice=${debouncedPrice[1]}`: ""}&type=newArrival`
          );
          break;

        case "product-category":
        case "discounted-products":
        case "search-product":
          res = await ApiGetAllProducts(
            `?limit=${LIMIT}&offset=${currentOffset}${slug ? `&categorySlug=${encodeURIComponent(slug)}` : ""}${selectedDiscount ? `&discount=${selectedDiscount}` : ""}${selectedColors?.length > 0 ? `&colorId=${selectedColors?.join(",")}` : ""}${searchTerm ? `&searchTerm=${searchTerm?.trim()}` : ""}${selectedSizes?.length > 0 ? `&sizeId=${selectedSizes?.join(",")}` : ""}${debouncedPrice?.length > 0? `&minPrice=${debouncedPrice[0]}&maxPrice=${debouncedPrice[1]}`: ""}`
          );
          break;

        default:
          res = await ApiGetAllProducts(
            `?limit=${LIMIT}&offset=${currentOffset}${slug ? `&categorySlug=${encodeURIComponent(slug)}` : ""}${selectedDiscount ? `&discount=${selectedDiscount}` : ""}${selectedColors?.length > 0 ? `&colorId=${selectedColors?.join(",")}` : ""}${searchTerm ? `&searchTerm=${searchTerm?.trim()}` : ""}${selectedSizes?.length > 0 ? `&sizeId=${selectedSizes?.join(",")}` : ""}${debouncedPrice?.length > 0? `&minPrice=${debouncedPrice[0]}&maxPrice=${debouncedPrice[1]}`: ""}`
          );
          break;
      }

      if (res?.success) {
        const newProducts = res.data || [];

        setProducts((prev) =>
          reset ? newProducts : [...prev, ...newProducts]
        );

        setHasMore(newProducts.length === LIMIT);
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setProducts([]);
    setOffset(0);
    setHasMore(true);

  loadProducts(0, true);
  }, [type,slug, searchTerm, selectedDiscount, selectedColors, selectedSizes, debouncedPrice]);


  const handleLoadMore = () => {
    if (loadingRef.current || !hasMore) return;

    const nextOffset = offset + LIMIT;
    setOffset(nextOffset);
    loadProducts(nextOffset);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          handleLoadMore();
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => observer.disconnect();
  }, [hasMore, offset]);


  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);

  const handleColorChange = (colorId: number) => {
    setSelectedColors((prev) =>
      prev.includes(colorId)
        ? prev.filter((id) => id !== colorId)
        : [...prev, colorId]
    );
  };

  const handleSizeChange = (sizeId: number) => {
    setSelectedSizes((prev) =>
      prev.includes(sizeId)
        ? prev.filter((id) => id !== sizeId)
        : [...prev, sizeId]
    );
  };

  const handlePriceChange = (_: Event, newValue: number | number[]) => {
    setPrice(newValue as number[])
  }

  const filterProps = {
    price,
    onPriceChange: handlePriceChange,
    selectedDiscount,
    setSelectedDiscount,
    selectedColors,
    selectedSizes,
    handleColorChange,
    handleSizeChange

  }
  return (
    <Box className='h-content w-100 p-3 p-md-5 position-relative'>

      {/* ── Mobile filter bar ── */}
      <Box
        className='d-flex d-md-none align-items-center justify-content-between mb-3'
      >
        <Typography className='fs-14 text-white'>Shoes - 4527 items</Typography>
        <Button
          startIcon={<FilterList />}
          variant='outlined'
          size='small'
          className='btn-outlined'
          onClick={() => setFilterDrawerOpen(true)}
        >
          Filters
        </Button>
      </Box>

      {/* ── Mobile Filter Drawer ── */}
      <Drawer
        anchor='left'
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        slotProps={{
          paper: { sx: { width: 300, bgcolor: 'var(--primary-bg-color)', overflowX: 'hidden' } }
        }}
      >
        {/* Drawer header */}
        <Box className='d-flex align-items-center justify-content-between p-3'>
          <Typography className='text-white fw-bold fs-18'>FILTERS</Typography>
          <IconButton onClick={() => setFilterDrawerOpen(false)} sx={{ color: 'white' }}>
            <Close />
          </IconButton>
        </Box>

        <FilterContent {...filterProps} />

        {/* Apply button */}
        <Box className='p-3'>
          <Button variant='contained' fullWidth className='btn-main' onClick={() => setFilterDrawerOpen(false)}>
            Apply Filters
          </Button>
        </Box>
      </Drawer>

      <Grid container>

        {/* ── Desktop Sidebar Filters ── */}
        <Grid size={{ xs: 0, sm: 3.5, lg: 3, xl: 2.5 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Typography className='fs-14 text-white mb-2'>Shoes - 4527 items</Typography>
          <Typography className='text-white fw-bold fs-18 mb-4'>FILTERS</Typography>
          <Box className='px-2'>
            <FilterContent {...filterProps} />
          </Box>
        </Grid>

        {/* ── Product Grid ── */}
        <Grid size={{ xs: 12, sm: 8.5, lg: 9, xl: 9.5 }} className='overflow-hidden'>
          <Grid container spacing={{ xs: 2, md: 2 }} className='w-100' sx={{ flexWrap: 'wrap' }}>
            {products?.length ? (
              products.map((product: Product, i: number) => (
                <Grid key={i} size={{ xs: 6, sm: 4, xl: 3 }}>
                  <ProductCard product={product} />
                </Grid>
              ))
            ) : (
              loading ? Array.from({ length: 20 }).map((_, index) => (
                <Grid key={index} size={{ xs: 6, sm: 4, xl: 3 }}>
                  <Shimmer
                    height={{
                      xs: "250px",
                      md: "250px",
                      lg: "300px",
                    }}
                    width="100%"
                    borderRadius={5}
                  />
                </Grid>
              ))
                : (
                  <Box className='mt-5 mx-auto'>
                    <Typography className='text-white fs-20 m-auto mt-5'>No Products Found</Typography>
                  </Box>
                )
            )}

            {loading && products?.length > 0 &&
              Array.from({ length: 8 }).map((_, index) => (
                <Grid key={`load-more-${index}`} size={{ xs: 6, sm: 4, xl: 3 }}>
                  <Shimmer
                    height={{
                      xs: "250px",
                      md: "250px",
                      lg: "300px",
                    }}
                    width="100%"
                    borderRadius={5}
                  />
                </Grid>
              ))}

            <Grid size={12}>
              <div ref={observerRef} style={{ height: 20 }} />
            </Grid>
          </Grid>
        </Grid>

      </Grid>
    </Box>
  )
}

export default ProductListing